// AYUMCURE BUILD v45-2026-08-28
(function(){
  var body=document.body;
  function openEl(el){ if(!el)return; el.classList.add('is-open'); body.classList.add('is-open'); }
  function closeAll(){ document.querySelectorAll('.drawer,.panel,.srch').forEach(function(e){e.classList.remove('is-open');}); body.classList.remove('is-open'); }
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-open]');
    if(t){ e.preventDefault(); var sel=t.getAttribute('data-open');
      if(sel==='cart'&&t.dataset.cartType==='page'){location.href='/cart';return;}
      closeAll(); openEl(document.querySelector(sel==='cart'?'.drawer':sel==='menu'?'.panel':'.srch')); return; }
    if(e.target.closest('[data-close]')||e.target.classList.contains('scrim')){ closeAll(); }
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeAll(); });

  // countdown to midnight
  var cd=document.querySelector('[data-countdown]');
  if(cd){ (function tick(){ var n=new Date(),e=new Date(n); e.setHours(24,0,0,0);
    var s=Math.max(0,Math.floor((e-n)/1000)), p=function(v){return String(v).padStart(2,'0');};
    cd.innerHTML='<span>'+p(Math.floor(s/3600))+'</span>:<span>'+p(Math.floor(s/60)%60)+'</span>:<span>'+p(s%60)+'</span>';
    setTimeout(tick,1000); })(); }

  // hero slider: cycles the [data-slide] children, dots built here
  (function(){
    var hero = document.querySelector('[data-hero]'); if(!hero) return;
    var slides = hero.querySelectorAll('[data-slide]');
    var dotWrap = hero.querySelector('[data-hero-dots]');
    if(slides.length < 2){ if(dotWrap) dotWrap.remove(); return; }

    var i = 0, ms = parseInt(hero.getAttribute('data-autoplay'), 10);
    if(isNaN(ms)) ms = 6500;

    var html = '';
    for(var k = 0; k < slides.length; k++) html += '<button type="button" aria-label="Slide ' + (k+1) + '"></button>';
    dotWrap.innerHTML = html;
    var dots = dotWrap.querySelectorAll('button');

    function show(n){
      i = (n + slides.length) % slides.length;
      for(var k = 0; k < slides.length; k++){
        slides[k].hidden = k !== i;
        dots[k].setAttribute('aria-current', k === i ? 'true' : 'false');
      }
    }
    for(var d = 0; d < dots.length; d++){
      (function(k){ dots[k].addEventListener('click', function(){ show(k); restart(); }); })(d);
    }
    var timer = null;
    function restart(){ if(timer) clearInterval(timer); if(ms > 0) timer = setInterval(function(){ show(i + 1); }, ms); }
    show(0); restart();
  })();

  // rails
  document.querySelectorAll('[data-rail-prev]').forEach(function(b){ b.addEventListener('click',function(){
    var r=document.querySelector(b.dataset.railPrev); r.scrollBy({left:-r.clientWidth*.8,behavior:'smooth'}); }); });
  document.querySelectorAll('[data-rail-next]').forEach(function(b){ b.addEventListener('click',function(){
    var r=document.querySelector(b.dataset.railNext); r.scrollBy({left:r.clientWidth*.8,behavior:'smooth'}); }); });

  // concern tabs
  document.querySelectorAll('[data-tabs]').forEach(function(w){
    w.querySelectorAll('.chip').forEach(function(c){ c.addEventListener('click',function(){
      w.querySelectorAll('.chip').forEach(function(x){ x.setAttribute('aria-selected','false'); });
      c.setAttribute('aria-selected','true');
      w.querySelectorAll('[data-panel]').forEach(function(p){ p.hidden = p.dataset.panel!==c.dataset.tab; });
    }); });
  });

  // product gallery: thumbnails swap the main image
  document.querySelectorAll('[data-gallery]').forEach(function(g){
    var main = g.querySelector('[data-gal-main]');
    var picks = g.querySelectorAll('[data-gal-pick]');
    if(!main || !picks.length) return;
    picks.forEach(function(t){
      t.addEventListener('click', function(){
        main.src = t.dataset.galPick;
        main.removeAttribute('srcset');
        picks.forEach(function(x){ x.setAttribute('aria-current','false'); });
        t.setAttribute('aria-current','true');
      });
    });
  });

  // qty steppers
  document.addEventListener('click',function(e){
    var s=e.target.closest('[data-qty]'); if(!s)return;
    var inp=s.parentElement.querySelector('input');
    var v=parseInt(inp.value,10)||1; inp.value=Math.max(1,v+(s.dataset.qty==='up'?1:-1));
    if(inp.form&&inp.dataset.autosubmit) inp.form.requestSubmit();
  });

  // AJAX add to cart -> refresh drawer
  async function refreshDrawer(){
    var cur = document.querySelector('.drawer');
    if(!cur) return;
    var wasOpen = cur.classList.contains('is-open');
    var html = await (await fetch('/?section_id=cart-drawer')).text();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    // a section render may or may not be wrapped - handle both
    var fresh = doc.querySelector('.drawer');
    cur.innerHTML = fresh ? fresh.innerHTML : (doc.body ? doc.body.innerHTML : html);
    if(wasOpen) cur.classList.add('is-open');
    try{
      var c = await (await fetch('/cart.js')).json();
      document.querySelectorAll('[data-cart-count]').forEach(function(n){ n.textContent = c.item_count; });
    }catch(err){}
  }
  document.addEventListener('submit',async function(e){
    var f=e.target;
    if(f.matches('form[action*="/cart/add"]') && document.querySelector('.drawer')){
      e.preventDefault();
      var btn=f.querySelector('[type=submit]'); if(btn){btn.disabled=true;btn.dataset.l=btn.textContent;btn.textContent='Adding…';}
      try{ await fetch('/cart/add.js',{method:'POST',body:new FormData(f)}); await refreshDrawer();
        closeAll(); openEl(document.querySelector('.drawer')); }
      finally{ if(btn){btn.disabled=false;btn.textContent=btn.dataset.l;} }
    }
  });
  document.addEventListener('click',async function(e){
    var l=e.target.closest('[data-line-change]'); if(!l)return; e.preventDefault();
    await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({line:+l.dataset.line,quantity:+l.dataset.lineChange})});
    await refreshDrawer();
  });

  // buy it now
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-buy-now]'); if(!b) return;
    var f = document.getElementById('AddToCartForm'); if(!f) return;
    e.preventDefault();
    var picked = f.querySelector('[name="id"]:checked') || f.querySelector('[name="id"]');
    var qtyEl = f.querySelector('[name="quantity"]');
    var vid = picked ? picked.value : '';
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    if(!vid) return;
    b.disabled = true; b.textContent = 'Please wait\u2026';
    // cart permalink: this item only, straight to checkout - the existing bag is not billed
    window.location.href = '/cart/' + vid + ':' + qty + '?return_to=/checkout';
  });

  // judge.me: strip the inline styles it writes, so brand CSS wins
  (function(){
    var SEL = '.jdgm-rev, .jdgm-rev__body, .jdgm-rev__title, .jdgm-rev__author,' +
              '.jdgm-rev__timestamp, .jdgm-rev__reply, .jdgm-rev__reply *,' +
              '.jdgm-rev-widg__title, .jdgm-rev-widg__summary-average,' +
              '.jdgm-histogram__row, .jdgm-histogram__bar, .jdgm-histogram__frequency,' +
              '.jdgm-rev-widg, .jdgm-rev-widg__body, .jdgm-rev-widg__reviews,' +
              '.jdgm-widget .jdgm-write-rev-link';

    function clean(root){
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll(SEL).forEach(function(el){
        if(el.hasAttribute('style')) el.removeAttribute('style');
      });
    }

    var pending = null;
    function schedule(root){
      if(pending) cancelAnimationFrame(pending);
      pending = requestAnimationFrame(function(){ clean(root); pending = null; });
    }

    function watch(){
      var host = document.querySelector('.jdgm-widget, #judgeme_product_reviews');
      if(!host) return false;
      clean(document);
      new MutationObserver(function(muts){
        for(var i = 0; i < muts.length; i++){
          var m = muts[i];
          if(m.type === 'attributes' && m.attributeName === 'style'){ schedule(document); return; }
          if(m.addedNodes && m.addedNodes.length){ schedule(document); return; }
        }
      }).observe(host.parentNode || document.body, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['style']
      });
      return true;
    }

    if(!watch()){
      var tries = 0;
      var poll = setInterval(function(){
        tries += 1;
        if(watch() || tries > 40) clearInterval(poll);
      }, 500);
    }
  })();

  // predictive search
  (function(){
    var panel = document.querySelector('.srch'); if(!panel) return;
    var input = panel.querySelector('input[type="search"]');
    var box   = panel.querySelector('[data-srch-results]');
    var chips = panel.querySelector('[data-srch-chips]');
    if(!input || !box) return;
    var t, last = '';

    panel.querySelectorAll('[data-srch-term]').forEach(function(c){
      c.addEventListener('click', function(){ input.value = c.dataset.srchTerm; input.focus(); run(); });
    });

    function money(cents){
      var n = (Number(cents)/100);
      return '\u20B9' + n.toLocaleString('en-IN', {maximumFractionDigits: n % 1 ? 2 : 0});
    }
    function esc(s){ return String(s).replace(/[&<>"]/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

    function render(items, q){
      if(!items.length){
        box.innerHTML = '<p class="srch__empty">Nothing matched \u201C' + esc(q) + '\u201D. Try an ingredient or a concern.</p>';
      } else {
        box.innerHTML = items.map(function(p){
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
          var title = String(p.title).split('|')[0].trim();
          var sub = p.product_type || '';
          return '<a class="sres" href="' + p.url + '">' +
            (img ? '<img src="' + img + '&width=140" alt="" loading="lazy">' : '<span class="sres__ph"></span>') +
            '<span class="sres__t"><b>' + esc(title) + '</b>' +
            (sub ? '<span>' + esc(sub) + '</span>' : '') + '</span></a>';
        }).join('') +
        '<a class="sres__all" href="/search?q=' + encodeURIComponent(q) + '">See all results for \u201C' + esc(q) + '\u201D \u2192</a>';
      }
      box.hidden = false;
      if(chips) chips.hidden = true;
    }

    function run(){
      var q = input.value.trim();
      if(q.length < 2){ box.hidden = true; if(chips) chips.hidden = false; last=''; return; }
      if(q === last) return;
      last = q;
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(function(r){ return r.json(); })
        .then(function(d){
          var items = (d.resources && d.resources.results && d.resources.results.products) || [];
          if(input.value.trim() === q) render(items, q);
        })
        .catch(function(){ box.hidden = true; if(chips) chips.hidden = false; });
    }

    input.addEventListener('input', function(){ clearTimeout(t); t = setTimeout(run, 220); });
  })();

  // variant radio -> live price
  document.addEventListener('change', function(e){
    var r = e.target.closest('[data-variants] input[name="id"]'); if(!r) return;
    document.querySelectorAll('[data-price-now]').forEach(function(n){ if(r.dataset.price) n.textContent = r.dataset.price; });
    document.querySelectorAll('[data-price-was]').forEach(function(w){
      w.style.display = r.dataset.compare ? '' : 'none';
      if(r.dataset.compare) w.textContent = r.dataset.compare;
    });
  });

  // scroll reveal
  if(document.body.classList.contains('anim')&&'IntersectionObserver'in window){
    var io=new IntersectionObserver(function(en){ en.forEach(function(x){ if(x.isIntersecting){x.target.classList.add('in');io.unobserve(x.target);} }); },{rootMargin:'0px 0px -8% 0px',threshold:.05});
    var mark=function(){ document.querySelectorAll('[data-reveal]:not(.in):not([data-seen])').forEach(function(el){ el.dataset.seen=1;
      if(el.getBoundingClientRect().top < innerHeight*0.92){ el.classList.add('in'); } else io.observe(el); }); };
    mark(); document.addEventListener('shopify:section:load',mark);
  }

  // offer bar
  var ob=document.querySelector('.offer');
  if(ob && !localStorage.getItem('ayum_offer_hidden')){ setTimeout(function(){ob.classList.add('is-on');},600); }
  if(ob) ob.querySelector('.x').addEventListener('click',function(){ ob.classList.remove('is-on'); localStorage.setItem('ayum_offer_hidden','1'); });
})();

  // frequently bought together
  (function(){
    var root = document.querySelector('[data-fbt-root]'); if(!root) return;
    var wrap = root.querySelector('[data-fbt]');
    var pid = root.dataset.productId;
    var limit = parseInt(root.dataset.limit, 10) || 2;
    if(!pid || !wrap) return;

    function money(c){ var n = Number(c)/100;
      return '\u20B9' + n.toLocaleString('en-IN', { maximumFractionDigits: n % 1 ? 2 : 0 }); }
    function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

    function item(o){
      return '<label class="fbt__item' + (o.locked ? ' is-locked' : '') + '">' +
        '<input type="checkbox" checked' + (o.locked ? ' disabled' : '') +
          (o.id ? ' data-fbt-id="' + o.id + '"' : '') +
          ' data-fbt-price="' + o.price + '">' +
        '<span class="fbt__pic">' + (o.image ? '<img src="' + o.image + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="fbt__meta"><b>' + esc(String(o.title).split('|')[0].trim()) + '</b>' +
        '<span>' + (o.locked ? 'This item \u00B7 ' : '') + money(o.price) + '</span></span></label>';
    }

    function wire(){
      var boxes = wrap.querySelectorAll('input[type="checkbox"]');
      var totalEl = wrap.querySelector('[data-fbt-total]');
      var countEl = wrap.querySelector('[data-fbt-count]');
      var btn = wrap.querySelector('[data-fbt-add]');
      function sync(){
        var cents = 0, n = 0;
        boxes.forEach(function(b){ if(b.checked){ cents += Number(b.dataset.fbtPrice || 0); n += 1; } });
        if(totalEl) totalEl.textContent = money(cents);
        if(countEl) countEl.textContent = n;
        if(btn) btn.disabled = n < 1;
      }
      boxes.forEach(function(b){ b.addEventListener('change', sync); });
      sync();
      if(!btn) return;
      btn.addEventListener('click', async function(){
        var items = [], form = document.getElementById('AddToCartForm');
        if(form){
          var mid = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
          var q = form.querySelector('[name="quantity"]');
          if(mid) items.push({ id: Number(mid.value), quantity: Number(q && q.value || 1) });
        } else {
          items.push({ id: Number(root.dataset.variantId), quantity: 1 });
        }
        boxes.forEach(function(b){ if(b.checked && b.dataset.fbtId) items.push({ id: Number(b.dataset.fbtId), quantity: 1 }); });
        if(!items.length) return;
        var label = btn.textContent;
        btn.disabled = true; btn.textContent = 'Adding\u2026';
        try{
          await fetch('/cart/add.js', { method: 'POST',
            headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
          var d = document.querySelector('.drawer');
          if(d){
            var html = await (await fetch('/?section_id=cart-drawer')).text();
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('.drawer');
            d.innerHTML = fresh ? fresh.innerHTML : doc.body.innerHTML;
            d.classList.add('is-open');
            document.body.classList.add('is-open');
          }
          var c = await (await fetch('/cart.js')).json();
          document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = c.item_count; });
        } finally { btn.disabled = false; btn.textContent = label; }
      });
    }

    function paint(list){
      var html = item({ locked: true, title: root.dataset.productTitle,
        image: root.dataset.productImage, price: root.dataset.variantPrice });
      list.forEach(function(p){
        var v = p.variants && p.variants[0] ? p.variants[0].id : null;
        if(!v) return;
        html += '<span class="fbt__plus">+</span>' + item({ id: v, title: p.title,
          image: p.featured_image ? p.featured_image + '&width=300' : '', price: p.price });
      });
      wrap.innerHTML = '<div class="fbt__row">' + html + '</div>' +
        '<div class="fbt__foot"><div class="fbt__total">' +
        '<span class="eyebrow">Total for <em data-fbt-count>1</em> items</span>' +
        '<b data-fbt-total></b></div>' +
        '<button class="btn" type="button" data-fbt-add>' + esc(root.dataset.button || 'Add selected to bag') + '</button></div>';
      root.hidden = false;
      wire();
    }

    fetch('/recommendations/products.json?product_id=' + pid + '&limit=' + limit + '&intent=complementary')
      .then(function(r){ return r.json(); })
      .then(function(d){
        if(d.products && d.products.length) return d.products;
        return fetch('/recommendations/products.json?product_id=' + pid + '&limit=' + limit + '&intent=related')
          .then(function(r){ return r.json(); }).then(function(d2){ return d2.products || []; });
      })
      .then(function(list){ if(list.length) paint(list); })
      .catch(function(){});
  })();
